import { AbsoluteFill, interpolate, Sequence, useCurrentFrame, useVideoConfig } from 'remotion';

import { FONT_SIZE_SCALING, MARGIN_SCALING } from '@/constants';
import { VideoThemeText } from '@/types';

export type TextSequenceProps = {
  from: number;
  durationInFrames: number;
  textStyle: VideoThemeText;
  textValue: string | undefined;
};

export const TextSequence: React.FC<TextSequenceProps> = ({
  from,
  durationInFrames,
  textStyle,
  textValue
}) => {
  const currentFrame = useCurrentFrame();
  const { fps } = useVideoConfig();

  const opacity =
    textStyle.transitionTime === 0
      ? 1
      : currentFrame - from <= textStyle.transitionTime * fps
        ? interpolate(currentFrame - from, [0, textStyle.transitionTime * fps], [0, 1])
        : currentFrame - from >= durationInFrames - textStyle.transitionTime * fps
          ? interpolate(
              currentFrame - from,
              [durationInFrames - textStyle.transitionTime * fps, durationInFrames],
              [1, 0]
            )
          : 1;

  return (
    <Sequence from={from} durationInFrames={durationInFrames}>
      <AbsoluteFill className='pointer-events-none flex items-center justify-center'>
        <div
          style={{
            fontFamily: textStyle.fontFamily,
            fontSize: textStyle.fontSize * FONT_SIZE_SCALING,
            color: textStyle.textColor,
            marginTop: textStyle.marginTop * MARGIN_SCALING,
            marginBottom: textStyle.marginBottom * MARGIN_SCALING,
            marginLeft: textStyle.marginLeft * MARGIN_SCALING,
            marginRight: textStyle.marginRight * MARGIN_SCALING,
            textAlign: 'center',
            width: '100%',
            opacity: opacity
          }}>
          {textValue}
        </div>
      </AbsoluteFill>
    </Sequence>
  );
};
